import { createApp } from 'vue'
import './scss/index.scss'
import App from './App.vue'
import Autoscreening from './Autoscreening.vue'
import Catalogue from './Catalogue.vue'
import InternationalLoading from './InternationalLoading.vue'
import LeadForm from './LeadForm.vue'
import ScreeningHistory from './ScreeningHistory.vue'
import { Modal, Tab } from "bootstrap";
import i18n from "./messages";

createApp(App).use(i18n).mount('#org_selector')

createApp(ScreeningHistory).use(i18n).mount('#screening_history')
createApp(Autoscreening).use(i18n).mount('#autoscreening_table')
createApp(InternationalLoading).use(i18n).mount('#international_loading')
createApp(Catalogue).use(i18n).mount('#catalogue')

const leadFormElem = document.getElementById("lead_form");
if (leadFormElem) {
    const lang = leadFormElem.dataset.lang || 'cs';
    i18n.global.locale = lang;

    createApp(LeadForm).use(i18n).mount(leadFormElem);
}

// raw JS for selected product on add_credit.html
document.querySelectorAll("input[name='product_type']").forEach((box) => {
    box.addEventListener("click", function (event) {
        changePriceSelected(event.target.value)
    });
    if (box.checked) {
        changePriceSelected(box.value)
    }
});

function changePriceSelected(value) {
    var el = document.getElementById(value);
    var selected = document.getElementsByClassName("selectedPriceItem")
    for (var i = 0; i < selected.length; i++) {
        selected[i].classList.remove("selectedPriceItem");
    }
    el.classList.add("selectedPriceItem");
}

// subject.html, person.html: a screening of today says so when its subject comes out differently now
document.querySelectorAll("[data-sr-changed]").forEach((state) => {
    fetch(state.dataset.srChanged, { credentials: "same-origin", headers: { Accept: "application/json" } })
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
            if (data && data.changed) {
                state.hidden = false;
            }
        })
        .catch(() => {});
});

// subject.html: the dots of a person lead to the card of its risk, the card back to its persons
const screeningResult = document.querySelector(".sr");
if (screeningResult) {
    const riskRows = [...screeningResult.querySelectorAll("[data-sr-risks]")];

    const highlight = (elements) => {
        elements.forEach((element) => {
            element.classList.remove("sr-highlight");
            void element.offsetWidth;
            element.classList.add("sr-highlight");
        });
    };

    screeningResult.querySelectorAll("[data-sr-risk]").forEach((dot) => {
        const card = document.getElementById(dot.dataset.srRisk);
        if (!card) {
            dot.removeAttribute("href");
            return;
        }
        dot.addEventListener("click", (event) => {
            event.preventDefault();
            card.scrollIntoView({ behavior: "smooth", block: "center" });
            highlight([card]);
        });
    });

    screeningResult.querySelectorAll("[data-sr-show-persons]").forEach((button) => {
        const rows = riskRows.filter((row) => row.dataset.srRisks.split(" ").includes(button.dataset.srShowPersons));
        if (!rows.length) {
            return;
        }
        button.hidden = false;
        button.addEventListener("click", () => {
            // the persons rather than the owners, they list everybody
            const pane = (rows.find((row) => row.closest("#sr-tab-persons")) || rows[0]).closest(".tab-pane");
            const tab = screeningResult.querySelector(`[data-bs-target="#${pane.id}"]`);
            Tab.getOrCreateInstance(tab).show();
            const shown = rows.filter((row) => pane.contains(row));
            shown[0].scrollIntoView({ behavior: "smooth", block: "center" });
            highlight(shown);
        });
    });
}
